import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import { staticurl } from '../common/constants'
import { Link } from 'react-router-dom'
import { useStore } from '../context/StoreContext'

export default function Brands() {
    const [groupedBrands, setGroupedBrands] = useState(null);
    const { brands } = useStore();
    
    useEffect(() => {
        if (!brands) return;
        
        // Group by letter
        const grouped = brands.reduce((acc, brand) => {
            const firstLetter = brand.brandName[0].toUpperCase();
            if (!acc[firstLetter]) {
                acc[firstLetter] = [];
            }
            acc[firstLetter].push(brand);
            return acc;
        }, {});
        
        // Sort letters alphabetically
        const sortedGrouped = Object.keys(grouped).sort().reduce((acc, key) => {
            acc[key] = grouped[key];
            return acc;
        }, {});

        setGroupedBrands(sortedGrouped);
    }, [brands])

    // Filter own brands for Featured section
    const featuredBrands = brands ? brands.filter(b => b.ownBrand) : [];

    // Helper to scroll to section
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
             const headerOffset = 100; 
             const elementPosition = element.getBoundingClientRect().top;
             const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
             window.scrollTo({
                 top: offsetPosition,
                 behavior: "smooth"
             });
        }
    };

  return (
    <>
    <div className='container brands-page-container'>
       
       {/* Featured Brands Section - Full Width */}
       {featuredBrands.length > 0 && (
           <div className='featured-brands-section my-4' style={{padding: '20px'}}>
               <h3 className='brand-section-heading' style={{fontSize: '1.5rem', marginBottom: '15px'}}>Featured Brands</h3>
               <div className='featured-scroll-container'>
                   {featuredBrands.map(brand => (
                       <Link to={`/brands/${brand.brandName}`} key={brand._id} className='brand-card-compact brand-card-featured'>
                           <div className='brand-logo-wrapper'>
                               <img 
                                   src={brand.brandLogo ? `${staticurl}${brand.brandLogo}` : 'https://placehold.co/150x80?text=' + brand.brandName} 
                                   alt={brand.brandName}
                                   onError={(e) => {e.target.onerror = null; e.target.src='https://placehold.co/150x80?text=' + brand.brandName}}
                               />
                           </div>
                           <div className='brand-name-text'>{brand.brandName}</div>
                       </Link>
                   ))}
               </div>
           </div>
       )}

        <div className='row'>
            {/* Sidebar Navigation - Desktop Only */}
            <div className='col-md-2 sidebar-column'>
                <div className='sidebar-sticky'>
                    <h5 className='my-3' style={{fontFamily: 'Exo 2', fontWeight: 700}}>Browse</h5>
                    <div className='sidebar-nav-list'>
                        {groupedBrands && Object.keys(groupedBrands).map(letter => (
                             <button 
                                key={letter} 
                                onClick={() => scrollToSection(`letter-${letter}`)}
                                className='sidebar-link cursor-pointer'
                                style={{background: 'none', border: 'none', textAlign: 'left', width: '100%'}}
                             >
                                 {letter}
                             </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content - Brand Grid */}
            <div className='col-md-10'>
                <div className='all-brands-section'>
                    {groupedBrands && Object.keys(groupedBrands).map(letter => (
                        <div className='brand-letter-group' key={letter} id={`letter-${letter}`}>
                            <div className='brand-letter-header' style={{fontSize: '1.8rem', marginTop: '10px'}}>{letter}</div>
                            <div className='brand-grid-compact'>
                                {groupedBrands[letter].map(brand => (
                                    <Link to={`/brands/${brand.brandName}`} key={brand._id} className='brand-card-compact'>
                                        <div className='brand-logo-wrapper'>
                                             <img 
                                               src={brand.brandLogo ? `${staticurl}${brand.brandLogo}` : 'https://placehold.co/150x80?text=' + brand.brandName} 
                                               alt={brand.brandName}
                                               onError={(e) => {e.target.onerror = null; e.target.src='https://placehold.co/150x80?text=' + brand.brandName}}
                                           />
                                        </div>
                                        <div className='brand-name-text'>{brand.brandName}</div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    </div>
    <Footer />
    </>
  )
}
